import styled from '@emotion/styled';
import { css } from '@emotion/core';

export const DIVIDER_TYPE = {
  HORIZONTAL: 'HORIZONTAL',
  VERTICAL: 'VERTICAL',
};

const StyledDivider = styled.div`
  ${(props) =>
    props.type === DIVIDER_TYPE.HORIZONTAL
      ? css`
          height: 1px;
          width: 85%;
          margin: 10px auto;
        `
      : css`
          width: 1px;
          margin: 0 30px;
          height: auto;
        `}
  background-color: var(--color-background-medium);
`;

function Divider({ type = DIVIDER_TYPE.VERTICAL, ...props }) {
  return <StyledDivider type={type} {...props} />;
}

export default Divider;
